import { toast } from 'react-toastify'

import { generateAumhumLocalMailIdForUser } from 'src/clinic/components/ClinicManageBookingsPage/ClinicManageBookingsHelper'
import { buildPatientUpsertPayload } from 'src/clinic/components/ClinicManageBookingsPage/patientForm/utils/patientFormDataUtils'
import { getCPDataWithoutParams, postCPDataWithoutParams } from 'src/clinic/services'
import { BLANK_PATIENT_DATA } from 'src/consumer/constants'
import { getAgeFromDobWithTime, getDOBWithTime } from 'src/consumer/helpers/profilePageHelper'
import { ensurePlusPrefix } from 'src/consumer/helpers/utilFunctions'
// import {
//   ensurePlusPrefix,
//   getDataMapFromCommonResponse,
//   isCommonResponseSuccessful,
//   generateAumhumLocalMailIdForUser,
// } from 'src/consumer/helpers/utilityFunctions'
import { addOrUpdatePatientsInIdb } from 'src/emr/database/indexedDbDao'
import { getDataMapFromCommonResponse, isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'

export function cleanAttendantsArray(attendantsArray) {
  if (Array.isArray(attendantsArray)) {
    return attendantsArray.filter((item) => item?.name)
  }
  return []
}

export async function createNewPatient(
  clinicId,
  clinicBrandId,
  mentorProfileData,
  newPatientInputData,
  setNewPatientSubmissionLoading,
  forMentor,
  setSelectedPatient,
  setNewPatientInputData,
  setIsNewPatient,
  setRelatedToPatient,
  setRelatedPatientLoading,
  makeAnonymousPatient,
  createPatientApiSignature = '/api/secure/patient/new',
  patientSearchApiSignature = '/api/secure/mentor/patient/list',
  setPatientSaveMessage,
  canTakeImportId = false,
  defaultPatientImportedFrom,
) {
  console.log(newPatientInputData)
  let dataToSubmit = buildPatientUpsertPayload(newPatientInputData, {
    clinicId,
    clinicBrandId,
    mentorId: mentorProfileData?.id,
    anonymous: makeAnonymousPatient,
  })
  const addAddToRelatedPatientStateAfterCreation = newPatientInputData?.relatedToExistingPatient?.id || null
  if (
    Boolean(makeAnonymousPatient) &&
    !Boolean(dataToSubmit?.mobile) &&
    !Boolean(dataToSubmit?.email)
  ) {
    dataToSubmit.email = generateAumhumLocalMailIdForUser(dataToSubmit?.name)
  }
  if (canTakeImportId) {
    dataToSubmit.importData = {
      ...newPatientInputData?.importData,
      importedFrom: defaultPatientImportedFrom,
    }
  }

  setNewPatientSubmissionLoading(true)
  // distinction between clinic assistant api and mentor api
  let response
  if (forMentor) {
    response = await postCPDataWithoutParams(createPatientApiSignature, dataToSubmit)
  } else {
    response = await postCPDataWithoutParams(createPatientApiSignature, dataToSubmit)
  }
  if (response.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
    const returnedPatient = getDataMapFromCommonResponse(response)?.patient
    if (forMentor) {
      addOrUpdatePatientsInIdb([returnedPatient])
    }
    const toSetSelectedPatientData = {
      ...(response?.data?.data?.patient || {}),
      age: getAgeFromDobWithTime(response?.data?.data?.patient?.dateOfBirth),
    }
    setSelectedPatient(toSetSelectedPatientData)
    setNewPatientInputData(BLANK_PATIENT_DATA)
    setIsNewPatient(false)
    if (addAddToRelatedPatientStateAfterCreation) {
      setRelatedToPatient(null)
      setRelatedPatientLoading(true)
      const responseTwo = await getCPDataWithoutParams(
        `${patientSearchApiSignature}?patientId=${addAddToRelatedPatientStateAfterCreation}&clinicId=${clinicId}`,
      )
      setRelatedPatientLoading(false)
      if (responseTwo.status === 200 && responseTwo?.data && responseTwo?.data?.[0]) {
        setRelatedToPatient(responseTwo?.data?.[0])
      } else {
        toast.error('Error finding related patient data. Contact support.')
      }
    }
    return toSetSelectedPatientData
  } else {
    console.log({ response })
    if (response?.data?.code === 1011) {
      setPatientSaveMessage({
        type: 'error',
        message: 'Please create this patient as a relative of another patient.',
      })
    } else {
      setPatientSaveMessage({ type: 'error', message: 'Error creating new patient' })
    }
    toast.error('Error creating new patient', {
      autoClose: 2000,
    })
  }
  setNewPatientSubmissionLoading(false)
}
